import React, { useEffect, useState } from 'react';

// Components
import Radio from '../UI/Radio';
import Icon from '../Icon';
import * as S from './Styled';

// Utils
import cn from 'classnames';
import _get from 'lodash/get';
import { Tooltip } from 'antd';

const Button = ({ buttons, onSelect }) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (buttons.length) {
      setSelected(buttons[0].id);
    } else {
      setSelected(null);
    }
  }, [buttons]);

  const onSelectItem = id => {
    if (onSelect) {
      onSelect(id);
    }
    setSelected(id);
  };

  const icon = unit => {
    let type;
    switch (unit) {
      case 'plate':
        type = 'plate';
        break;
      case 'ampoule':
        type = 'ampoule';
        break;
      case 'flask':
        type = 'flask';
        break;
      default:
        type = null;
    }

    return type ? `${type}_gray` : null;
  };

  return (
    <S.GroupSwitch>
      {buttons.map(({ id, value, name, disabled, pack_info }, idx) => {
        const unit = _get(pack_info, 'unit_name', null);
        const iconName = icon(unit);

        return (
          <Tooltip title={value} key={id}>
            <S.Label
              htmlFor={id}
              className={cn({
                'is-active': selected === id,
              })}
              key={id}
              disabled={disabled}
            >
              <Radio
                id={id}
                name={name}
                value={value}
                defaultChecked={idx === 0}
                onChange={() => {
                  onSelectItem(id);
                }}
                disabled={disabled}
              />
              <S.Type>
                <Icon name={iconName} />
              </S.Type>
              <S.Value>
                <S.InnerText>{value}</S.InnerText>
              </S.Value>
            </S.Label>
          </Tooltip>
        );
      })}
    </S.GroupSwitch>
  );
};

export default Button;
